import { render, staticRenderFns } from "./IndexInfantil.vue?vue&type=template&id=f5ccf0fe"
import script from "./IndexInfantil.vue?vue&type=script&lang=js"
export * from "./IndexInfantil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports